
import { cartGet, cartAdd, cartGetCurrent, cartUpdate, cartChange } from '@process-creative/slate-theme-tools';

import { StateDependant, bindAssignedElements,generateStepId, generateDependencies } from './utils';
import { DefaultStepOptionState } from './types';

export const CLASS_OPEN = 'is-bundle-builder-open';


const getSectionMarkup = (index:number, title:string) => {
  const template = document.createElement('template');
  template.innerHTML = `
    <style>
      :host {
        display: block;
        width: 100%;
        background: #F5F2F0;
        padding: 5rem 1.25rem 0;
        overflow: hidden;
      }
      
      :host([step-id='CHSCLR']) {
        border-radius: 2rem 2rem 0 0;
        padding-top: 2.75rem;
      }

      :host(.is-hidden) {
        display: none;
      }
      
      :root {
        
      }
      
      .o-customiser__step {
        text-align: center;
      }
      
      .o-customiser__step-index {
        width: 2.5rem;
        height: 2.5rem;
        background: #FCFCFB;
        margin: 0 auto 1.5rem;
        display: inline-block;
        line-height: 2.5rem;
        text-align: center;
        font-size: .875rem;
        font-weight: 500;
        line-height: 2.625rem;
        border-radius: 50%;
      }
      
      .o-customiser__step-title {
        text-align: center;
        font-family: Recoleta, serif;
        font-size: 1.375rem;
        font-weight: 500;
        line-height: 1.75rem;
        margin: 0 0 2rem;
      }

      @media only screen and (min-width: 1100px) {
        :host {
          grid-column: 1 / 2;
          padding: 3.125rem 0;
          width: calc(100vw - 40.75rem);
          position: relative;
          overflow: visible;
        }
        
        :host([step-id='CHSCLR']) {
          padding-top: 1.5rem;
        }

        :host([step-id='RDRNTS']),
        :host([step-id='CRTSZE']) {
          //max-width: 49.25rem;
        }

        .o-customiser__step {
          text-align: left;
        }

        .o-customiser__step-index {
          width: 3rem;
          height: 3rem;
          line-height: 3rem;
          font-size: 1rem;
          line-height: 3rem;
          margin: 0;
        }

        .o-customiser__step-title-wrapper {
          display: inline-flex;
          align-items: center;
          margin: 0 1.25rem 2rem 0;
          gap: 1.25rem;
        }

        :host(.has-description) .o-customiser__step-title-wrapper {
          display: flex;
          margin-right: 0;
        }
        
        .o-customiser__step-title {
          font-size: 2rem;
          line-height: 2.5rem;
          margin: 0;
        }

        @media only screen and (min-width: 1750px) {
          :host {
            grid-column: 1 / 2;
            padding: 3.125rem 0;
            width: calc(100vw - 56rem);
            position: relative;
          }
        }
      }
    </style>
    <div class="o-customiser__step">
      <div class="o-customiser__step-title-wrapper">
        <h5 class="o-customiser__step-index">${index + 1}</h5>
        <h2 class="o-customiser__step-title">${title}</h2>
      </div>
      <slot></slot>
    </div>
  `;

  return template;
}

type SetStepData = {
  name:string;
  title:string;
}

export class CustomiserSection extends StateDependant {

  private stepIndex:number;
  private indexEl:HTMLHeadingElement;
  private titleEl:HTMLHeadingElement;

  private step_id:string;
  private step_title:string;
  private step_name:string;
  // private model_id_field:string;
  private data;

  constructor() {
    super();

    const stepIndex = this.getAttribute('step-index');
    const step_id = this.getAttribute('step-id');
    const step_title = this.getAttribute('step-title');
    const step_name = this.getAttribute('step-name');
    if (!stepIndex || !step_id || !step_title || !step_name) {
      console.log({
        stepIndex,
        step_id,
        step_title,
        step_name
      })
      console.error(`No step-index, step-id, step_name or step-title attribute found`, this);
    }
    const data = this.getAttribute('data');
    if (!data) {
      console.warn('You may need to supply some data for this option!', this);
    } else {
      this.data = JSON.parse(data);
      this.dependencies = generateDependencies(this.data);
      this.default_state = this.data.default_step_state;
      // this.model_id_field = this.model_id_field;
    }
    this.stepIndex = parseInt(stepIndex);
    this.step_id = step_id;
    this.step_title = step_title;
    this.step_name = step_name;


    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = getSectionMarkup(this.stepIndex, this.step_title);
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.indexEl = this.shadowRoot?.querySelector('.o-customiser__step-index')!;
    this.titleEl = this.shadowRoot?.querySelector('.o-customiser__step-title')!;

    this.setState(this.default_state);
  }

  public setStepIndex(index:number) {
    this.stepIndex = index;
    this.indexEl.textContent = index + 1;
  }

  private setStepTitle(title:string) {
    this.step_title = title;
    this.titleEl.textContent = title;
  }

  private setStepName(name:string) {
    this.step_name = name;
  }

  public setStepData(props:SetStepData) {
    this.setStepName(props.name);
    const newStepId = generateStepId(props.title);
    this.setStepTitle(props.title);
    this.setStepId(newStepId);
  }
}

if(!customElements.get('customiser-section')) {
  customElements.define('customiser-section', CustomiserSection);
}